import React, { useState } from 'react'
import { Card } from 'react-bootstrap'
import toast from 'react-hot-toast';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { updatePassword } from '../../Services/userService';

const UpdatePassword = () => {

    const [formData, setFormData] = useState({});
    const [showPassword, setShowPassword] = useState(false)
    const [password, setPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [loading, setLoading] = useState(false);

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = async () => {
        setLoading(true);

        if (!password || !newPassword || !confirmPassword) {
            toast.error("Please fill all fields");
            setLoading(false);
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error("New password and confirm password do not match");
            setLoading(false);
            return;
        }

        const body = {
            oldPassword: password,
            newPassword: newPassword,
        };

        const response = await updatePassword(body);

        if (response.status === "success") {
            toast.success(response.message);

            setPassword("");
            setNewPassword("");
            setConfirmPassword("");
        } else {
            toast.error(response.message);
        }

        setLoading(false);
    };


    return (
        <>
            <div className="section ">
                <div className="">
                    <div style={{
                        background: "var(--surface)",
                        border: "1px solid var(--border)",
                        borderRadius: "0px 0px 14px 14px",
                        padding: "20px 22px",
                    }}>
                        <div style={{ marginBottom: 16 }}>
                            <h3 style={{ fontFamily: "'Syne',sans-serif", fontSize: 16, fontWeight: 700, color: "var(--text)", margin: 0 }}>Update Password</h3>
                            <p style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 3 }}>Update your password</p>
                        </div>


                        <div className="row justify-content-center">

                            <div className="col-md-6">

                                <div>
                                    <label className="oms-form-label mb-2">Current Password</label>
                                    <div className="oms-search  w-100 mb-3">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Enter password"
                                            className="w-100"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <span style={{ color: "var(--text-muted)", fontSize: 14 }}>
                                            {showPassword ? <FaEyeSlash onClick={() => setShowPassword(!showPassword)} /> : <FaEye onClick={() => setShowPassword(!showPassword)} />}

                                        </span>
                                    </div>
                                </div>


                                <div>
                                    <label className="oms-form-label mb-2">New Password</label>
                                    <div className="oms-search  w-100 mb-3">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Enter password"
                                            className="w-100"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                        />
                                        <span style={{ color: "var(--text-muted)", fontSize: 14 }}>
                                            {showPassword ? <FaEyeSlash onClick={() => setShowPassword(!showPassword)} /> : <FaEye onClick={() => setShowPassword(!showPassword)} />}

                                        </span>
                                    </div>
                                </div>


                                <div>
                                    <label className="oms-form-label mb-2">Confirm New Password</label>
                                    <div className="oms-search  w-100 mb-3">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Enter password"
                                            className="w-100"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                        <span style={{ color: "var(--text-muted)", fontSize: 14 }}>
                                            {showPassword ? <FaEyeSlash onClick={() => setShowPassword(!showPassword)} /> : <FaEye onClick={() => setShowPassword(!showPassword)} />}

                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='mt-3 text-end '>
                            <button
                                className='oms-btn oms-btn-primary'
                                size='sm'
                                onClick={handleSubmit}
                            >
                                Update Password
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}


export default UpdatePassword